import Axios from 'axios';
import Cookies from 'js-cookie';

import AppConfig from 'config/App';

const request = is_external => {
  const ixn_auth = Cookies.getJSON('ixn') || {};
  const token = window.HEXURE_UQ_CONFIG?.id || '';

  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  };

  if (!is_external) {
    headers['Universal-QUOTER-TOKEN'] = token;
    headers['access-token'] = ixn_auth.access_token;
    headers['client'] = ixn_auth.client;
    headers['uid'] = ixn_auth.uid;
  }

  return Axios.create({
    baseURL: AppConfig.API_BASE_URL,
    headers
  });
};

const UniversalApi = {
  loadUniversalQuoter() {
    return request().get(`/v1/universal_quoter/${window.HEXURE_UQ_CONFIG?.id || ''}`);
  }
};
export default UniversalApi;
